import React from "react";
import { TransferSummaryContainer } from "../../../../../containers";
const TransferSummary = (props) => {
  return <TransferSummaryContainer {...props} />;
};

export default TransferSummary;
